export default __webpack_public_path__ + "static/pen-fbc5a3f796417c31aa3020465ac08b15.png";